"use client";

import React from "react";
import { Maximize2, X } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Dialog, DialogContent, DialogTrigger, DialogTitle, DialogDescription, DialogClose, DialogPortal, DialogOverlay } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
const galleryItems = [{
  id: 1,
  title: "Artisanal Hardscaping",
  description: "Hand-selected stone pavers meticulously laid to create a timeless outdoor living space.",
  image: "https://fun-tiger.10web.cloud/wp-content/uploads/2026/04/20220408_154703-scaled.jpg?v=p4js2stabp",
  category: "HARDSCAPE"
}, {
  id: 2,
  title: "Curated Estate Gardens",
  description: "Lush, sustainable plantings that harmonize with the local Rockland County architecture.",
  image: "https://fun-tiger.10web.cloud/wp-content/uploads/2026/04/Landscaping-image-1.webp?v=4mxfysdsvdp",
  category: "Design"
}, {
  id: 3,
  title: "Precision Turf Management",
  description: "Advanced lawn care and soil restoration for a deep, healthy, and vibrant green finish.",
  image: "https://fun-tiger.10web.cloud/wp-content/uploads/2026/04/landscaping-image-5.avif?v=bssidj6vw8",
  category: "Lawn Care"
}, {
  id: 4,
  title: "Modern Retaining Walls",
  description: "Architectural structural solutions that combine engineering stability with natural beauty.",
  image: "https://fun-tiger.10web.cloud/wp-content/uploads/2026/04/landscaping-image-2.jpg?v=64m2wjzoval",
  category: "Construction"
}, {
  id: 6,
  title: "Seasonal Refresh",
  description: "Comprehensive clean-up and mulching to protect your investment through every season.",
  image: "https://fun-tiger.10web.cloud/wp-content/uploads/2026/04/Landscaping-image-8.jpg?v=8hl7t7j9c8f",
  category: "Maintenance"
}];
export default function Gallery() {
  return <section data-section-id="32527" id="gallery" className="relative w-full py-24 bg-background overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none">
        <div className="absolute top-[20%] left-[10%] w-[500px] h-[500px] bg-primary/5 rounded-full blur-[120px]" />
        <div className="absolute bottom-[20%] right-[10%] w-[400px] h-[400px] bg-accent/5 rounded-full blur-[100px]" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-default font-bold tracking-tight text-primary mb-4">What we&nbsp;<span className="text-secondary" data-ast-id="f:/src/pages/Services/sections/Gallery.tsx|sig:a1jrx1" data-ast-start="2563" data-ast-end="2618">Provide<br /></span></h2>
          <p className="text-lg font-sans text-muted-foreground">We provide to you all the services you need to keep your home and business looking the best it can be year round. See what Twins Landscaping Corp can do for you.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {galleryItems.map((item, i) => <Dialog key={item.id}>
              <DialogTrigger asChild>
                <div data-index={i} className="group relative cursor-pointer rounded-sm overflow-hidden border border-border bg-card/50 backdrop-blur-sm transition-all duration-500 hover:border-primary/50 hover:shadow-[0_0_20px_-5px_var(--color-primary)]">
                  <AspectRatio ratio={16 / 9}>
                    <img src={item.image} alt={item.title} className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-105" />
                    
                    {}
                    <div className="absolute inset-0 bg-gradient-to-t from-primary/90 via-primary/20 to-transparent opacity-80 transition-opacity duration-300 group-hover:opacity-90" />
                    
                    {}
                    <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <div className="bg-background/20 backdrop-blur-md border border-white/20 p-3 rounded-sm text-white">
                        <Maximize2 className="w-6 h-6" />
                      </div>
                    </div>

                    {}
                    <div className="absolute bottom-0 left-0 w-full p-5 translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
                      <p className="text-xs font-semibold mb-1 uppercase tracking-widest !text-[hsl(142,69%,58%)]">
                        {item.category}
                      </p>
                      <h3 className="text-xl font-default font-semibold text-white leading-tight">
                        {item.title}
                      </h3>
                    </div>
                  </AspectRatio>
                </div>
              </DialogTrigger>

              {}
              <DialogPortal>
                <DialogOverlay className="bg-primary/80 backdrop-blur-md" />
                <DialogContent showCloseButton={false} className="max-w-5xl w-[95vw] p-0 border-none bg-transparent shadow-none sm:rounded-sm overflow-hidden">
                  <div className="relative w-full bg-background/95 backdrop-blur-xl border border-border rounded-sm overflow-hidden shadow-2xl">
                    {}
                    <DialogClose className="absolute top-4 right-4 z-50 p-2 rounded-sm bg-primary/50 text-white hover:bg-accent-foreground hover:text-white transition-colors border border-white/10">
                      <X className="w-5 h-5" />
                      <span className="sr-only">Close</span>
                    </DialogClose>

                    <div className="flex flex-col">
                      {}
                      <div className="relative w-full aspect-video bg-black/5">
                        <img src={item.image} alt={item.title} className="w-full h-full object-contain" />
                      </div>
                      
                      {}
                      <div className="p-6 md:p-8 border-t border-border bg-card/50">
                        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                          <div>
                            <DialogTitle className="text-3xl font-default font-bold text-primary mb-2">
                              {item.title}
                            </DialogTitle>
                            <DialogDescription className="text-muted-foreground font-sans text-base">
                              {item.description}
                            </DialogDescription>
                          </div>
                          <div className="shrink-0">
                            <Button variant="outline" className="rounded-sm border-primary/20 text-primary hover:bg-primary/10 hover:text-primary">
                              View Project
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </DialogContent>
              </DialogPortal>
            </Dialog>)}
        </div>
      </div>
    </section>;
}